import * as React from 'react';
import { useEffect } from 'react';
import salt from "../../assets/icon/salt.gif";
import butter from "../../assets/icon/butter.gif";
import sugar from "../../assets/icon/sugar.gif";
import iconlike from "../../assets/icon/iconlike.gif";
import { useNavigate } from 'react-router-dom';
import careStore from "../../store/careStore";

import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import api from "../../utils/api";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from '@mui/material/Skeleton';
import * as util from "../../utils/util";

const recipeObj = {
  category: '',
  cholesterol: '',
  content: '',
  description: '',
  disease: '',
  efficacy: '',
  id: '',
  kcal: '',
  materials: '',
  name: '',
  process: '',
  salt: '',
  sfa: '',
  sugar: '',
  thumbnail: '',
  type: '',
  update_date: '',
  url: ''
}

const CareMenu = () => {
  const storeData: any = careStore();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [recipeRecommend, setRecipeRecommned] = React.useState(recipeObj);
  const [customerProgram, setCustomerProgram] = React.useState({
    aerobic: '',
    attention: '',
    cholesterol: '',
    create_date: '',
    exerciseRecommand: [],
    exercisetime: '',
    fat: '',
    member_id: '',
    month: '',
    program_name: '',
    recipe_kcal_100: recipeObj,
    recipe_kcal_200: recipeObj,
    recipe_kcal_300: recipeObj,
    recipe_kcal_400: recipeObj,
    recipe_kcal_500: recipeObj,
    recipe_recommend: recipeObj,
    recommandedcalperday: '',
    salt: '',
    stretching: [],
    sugar: '',
    week: '',
    weight: [],
    worktime: '',
    year: ''
  });

  useEffect(() => {

    setLoading(true);
    // 맞춤플랜 상황에 맞게 조회해오기
    if (storeData.careInfo.reset === 'Y') { // 맞춤플랜 재설정을 통해 이 화면에 들어왔을 때
      getPlan();
      storeData.setCareInfo('reset', '');
    } else {
      setTimeout(() => {
        api.get(`app/api/v1/AP_004_002`).then(res => {
          const planCode = res.data.result_code;
          if (planCode === '0') { // 생성된 맞춤플랜 있음(7일 지나지 않음)
            const resultData = JSON.parse(res.data.result_data);
            setCustomerProgram(resultData);
            setRecipeRecommned(resultData.recipe_recommend);
          } else if (planCode === '100') {  // 맞춤플랜 생성 전 or 맞춤플랜 산출 7일 지나서 재생성
            getPlan();
          }
          setLoading(false);
        }).catch(function (error) {
          console.log(error)
        });
      }, 500);
    }

  }, []);

  // 맞춤플랜 생성(최초 생성, 7일 지나서 재생성 포함)
  function getPlan() {
    api.post(`app/api/v1/AP_004_003`, storeData.careInfo).then(res => {
      const resultData = JSON.parse(res.data.result_data);
      setCustomerProgram(resultData);
      setRecipeRecommned(resultData.recipe_recommend);
    }).catch(function (error) {
      console.log(error)
    });
  }

  function handleClickKcalFood(recipe: any) {
    setRecipeRecommned(recipe);
    document.body.scrollIntoView({ behavior: 'auto' });
  }



  return (

    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 13, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="케 어" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box sx={{ boxSizing: 'border-box', }}>
          {loading ? (
            <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
              <Skeleton variant="rounded" height={30} width="60%" sx={{ mt: 4 }} />
            </Box>
          ) : (
            <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
              {customerProgram.year}.{customerProgram.month}. [{customerProgram.week}주차]
            </Typography>
          )}

          {loading ? (
            <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
              <Skeleton variant="rounded" height={36} width="100%" sx={{ mt: 3 }} />
            </Box>
          ) : (
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              <CareButton variant="contained" sx={{}}
                onClick={() => {
                  navigate('/care/CareMenu');
                }}
              >
                맞춤식단
              </CareButton>
              <CareButton variant="contained" sx={{ bgcolor: '#FFB068', color: '#fff' }}
                onClick={() => {
                  navigate('/care/CareSports');
                }}
              >
                맞춤운동
              </CareButton>
            </Stack>
          )}


          <React.Fragment>
            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={20} width="80%" sx={{ mt: 4 }} />
              </Box>
            ) : (
              <Typography component="div" sx={{ fontSize: 16, fontWeight: 600, color: '#555', m: 4, mb: 0, textAlign: 'center' }}>
                하루에 이 만큼까지만 드셔보세요!
              </Typography>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={180} width="100%" sx={{ mt: 3 }} />
              </Box>
            ) : (
              <Box sx={{m:'20px auto 0px auto', bgcolor: '#fff', p: '10px', borderRadius: 5, boxSizing: 'border-box', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
                <Stack direction="row" justifyContent="center" alignItems="baseline" spacing={1} sx={{ mb: 1 }} >
                  <Typography component="span" sx={{ fontSize: 30, color: '#EF8322', m: 0, mb: 0, fontWeight: 700 }}>
                    {util.formatComma(Math.abs(Number(customerProgram.recommandedcalperday)))}
                  </Typography>
                  <Typography component="span" sx={{ fontSize: 14, color: '#777', m: 0, mb: 0, fontWeight: 500 }}>
                    kcal
                  </Typography>
                </Stack>

                <Divider variant="middle" />

                <Stack direction="row" spacing={2}
                  sx={{
                    m: 1,
                    '& .MuiStack-root': { flex: 1, alignItems: 'center' },
                    '& .MuiAvatar-root': { border: '1px solid #ef8322', mt: 1 },
                    '& .MuiTypography-root': { fontSize: 12, color: '#555', textAlign: 'center', mt: 1 },
                    '& .subText': { fontSize: 14, fontWeight: 400, textAlign: 'center', m: 0 },
                  }}>
                  <Stack direction="column" justifyContent="center">
                    <Avatar alt="" src={salt} sx={{}} />
                    <Typography component="div" sx={{}}>
                      소금
                    </Typography>
                    <Typography component="div" className='subText'>
                      {util.formatComma(Math.round(Math.abs(Number(customerProgram.salt))))} g
                    </Typography>
                  </Stack>

                  <Stack direction="column" justifyContent="center">
                    <Avatar alt="" src={sugar} sx={{}} />
                    <Typography component="div" >
                      총당류
                    </Typography>
                    <Typography component="div" className='subText'>
                      {util.formatComma(Math.round(Math.abs(Number(customerProgram.sugar))))} g
                    </Typography>
                  </Stack>

                  <Stack direction="column" justifyContent="center">
                    <Avatar alt="" src={butter} sx={{}} />
                    <Typography component="div">
                      포화지방산
                    </Typography>
                    <Typography component="div" className='subText'>
                      {util.formatComma(Math.round(Math.abs(Number(customerProgram.fat))))} g
                    </Typography>
                  </Stack>

                  <Stack direction="column" justifyContent="center">
                    <Avatar alt="" src={iconlike} sx={{}} />
                    <Typography component="div">
                      콜레스테롤
                    </Typography>
                    <Typography component="div" className='subText'>
                      {util.formatComma(Math.round(Math.abs(Number(customerProgram.cholesterol))))} mg
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            )}
            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'right', }} justifyContent='end' alignContent={'end'}>
                <Skeleton variant="rounded" height={20} width="90%" sx={{ mt: 1 }} />
              </Box>
            ) : (

              <Typography sx={{ textAlign: 'right', fontSize: 11, color: '#aaa', mt: 1, mb:3  }}>출처 : 식품안전나라, <a href="https://www.foodsafetykorea.go.kr/main.do" title="식품안전나라" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11 }}>https://www.foodsafetykorea.go.kr </a></Typography>
            )}


            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={960} width="100%" sx={{ mt: 3 }} />
              </Box>
            ) : (

              <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', bgcolor: '#fff', borderRadius: 5, boxSizing: 'border-box', m: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 16, fontWeight: 600, color: '#777', m: 'auto', textAlign: 'center', p: '15px 0 10px 0', bgcolor: '#fff', borderRadius: '15px 15px 0 0 ', }}>
                  추천 레시피
                </Typography>
                <Card sx={{  borderRadius: '0 0 15px 15px', }}>
                  <CardMedia
                    sx={{ height: 250 }}
                    component="img"
                    alt="recipe"
                    image={recipeRecommend.thumbnail}
                    title=""
                  />
                  <Typography component="div" sx={{ fontSize: 16, textAlign: 'center', fontWeight: 800, color: '#555', m: 'auto', p: '15px 0', }}>
                    {recipeRecommend.name + ' (' + util.formatComma(recipeRecommend.kcal) + 'kcal)'}
                  </Typography>
                  <Divider />

                  <CardContent sx={{ bgcolor: '#f9f9f9' }}>
                    <Typography component="div" sx={{ fontSize: 16, fontWeight: 800, color: '#EF8322', }}>
                      재료
                    </Typography>

                    <Box sx={{
                      p: 1,
                      '& .material': { fontSize: 14, lineHeight: 1.8 },
                      fontSize: 14,
                    }}>
                      {recipeRecommend.materials.split('\r\n').map((item: any, index: any) => (
                        <Typography component="div" className='material' key={index}>
                          {item}
                        </Typography>
                      ))}
                    </Box>
                  </CardContent>

                  <Divider />
                  <CardContent>
                    <Typography component="div" sx={{ fontSize: 16, fontWeight: 800, color: '#EF8322', }}>
                      조리과정
                    </Typography>

                    <Box sx={{
                      p: 1,
                      '& .material': { fontSize: 14, lineHeight: 1.8 },
                      fontSize: 14,
                    }}>
                      {recipeRecommend.process.split('\r\n').map((item: any, index: any) => (
                        <Typography component="div" className='material' key={index}>
                          {item}
                        </Typography>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'right', }} justifyContent='end' alignContent={'end'}>
                <Skeleton variant="rounded" height={20} width="100%" sx={{ mt: 1 }} />
              </Box>
            ) : (

              <Typography sx={{ textAlign: 'right', fontSize: 11, color: '#aaa', mt: 1 }}>출처 : 듀얼헬스케어,<a href="https://blog.naver.com/dualhealth_official" title="Dualheathcare" target='_blank' style={{ color: '#aaa', textDecoration: 'none' }}> https://blog.naver.com/dualhealth_official</a></Typography>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={20} width="60%" sx={{ mt: 4 }} />
              </Box>
            ) : (
              <Typography component="div" sx={{ fontSize: 16, fontWeight: 600, color: '#555', m: 4, mb: 2, textAlign: 'center' }}>
                칼로리별 건강 음식
              </Typography>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 3 }} />
              </Box>
            ) : (
              <Accordion sx={accordionStyle}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography sx={{}}>500kcal대 건강음식</Typography>
                </AccordionSummary>
                <AccordionDetails onClick={() => handleClickKcalFood(customerProgram.recipe_kcal_500)}>
                  <Stack direction="row" spacing={2}>
                    <Typography>
                      {customerProgram.recipe_kcal_500.name}
                    </Typography>
                    <Typography sx={{ justifyContent: 'end', display: 'flex', flex: 1, fontWeight: '600' }}>
                      {customerProgram.recipe_kcal_500.kcal} kcal
                    </Typography>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 1 }} />
              </Box>
            ) : (
              <Accordion sx={accordionStyle}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography>400kcal대 건강음식</Typography>
                </AccordionSummary>
                <AccordionDetails onClick={() => handleClickKcalFood(customerProgram.recipe_kcal_400)}>
                  <Stack direction="row" spacing={2}>
                    <Typography>
                      {customerProgram.recipe_kcal_400.name}
                    </Typography>
                    <Typography sx={{ justifyContent: 'end', display: 'flex', flex: 1, fontWeight: '600' }}>
                      {customerProgram.recipe_kcal_400.kcal} kcal
                    </Typography>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 1 }} />
              </Box>
            ) : (
              <Accordion sx={accordionStyle}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography>300kcal대 건강음식</Typography>
                </AccordionSummary>
                <AccordionDetails onClick={() => handleClickKcalFood(customerProgram.recipe_kcal_300)}>
                  <Stack direction="row" spacing={2}>
                    <Typography>
                      {customerProgram.recipe_kcal_300.name}
                    </Typography>
                    <Typography sx={{ justifyContent: 'end', display: 'flex', flex: 1, fontWeight: '600' }}>
                      {customerProgram.recipe_kcal_300.kcal} kcal
                    </Typography>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 1 }} />
              </Box>
            ) : (
              <Accordion sx={accordionStyle}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography>200kcal대 건강음식</Typography>
                </AccordionSummary>
                <AccordionDetails onClick={() => handleClickKcalFood(customerProgram.recipe_kcal_200)}>
                  <Stack direction="row" spacing={2}>
                    <Typography>
                      {customerProgram.recipe_kcal_200.name}
                    </Typography>
                    <Typography sx={{ justifyContent: 'end', display: 'flex', flex: 1, fontWeight: '600' }}>
                      {customerProgram.recipe_kcal_200.kcal} kcal
                    </Typography>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 1 }} />
              </Box>
            ) : (
              <Accordion sx={accordionStyle}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography>100kcal대 건강음식</Typography>
                </AccordionSummary>
                <AccordionDetails onClick={() => handleClickKcalFood(customerProgram.recipe_kcal_100)}>
                  <Stack direction="row" spacing={2}>
                    <Typography>
                      {customerProgram.recipe_kcal_100.name}
                    </Typography>
                    <Typography sx={{ justifyContent: 'end', display: 'flex', flex: 1, fontWeight: '600' }}>
                      {customerProgram.recipe_kcal_100.kcal} kcal
                    </Typography>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'right', }} justifyContent='end' alignContent={'end'}>
                <Skeleton variant="rounded" height={20} width="70%" sx={{ mt: 1 }} />
              </Box>
            ) : (
              <Typography sx={{ textAlign: 'right', fontSize: 11, color: '#aaa', mt: 1}}>출처 : 한국영양학회, <a href="https://www.kns.or.kr/" title="한국영양학회" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11}}>https://www.kns.or.kr </a></Typography>
            )}
          </React.Fragment>

        </Box>

        {loading ? (
          <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
            <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 3, }} />
          </Box>
        ) : (
          <Box sx={BtnStyle}>
            <Button variant="contained" sx={BottomBtnStyle}
              onClick={() => {
                storeData.setCareInfo('height', '');
                storeData.setCareInfo('weight', '');
                storeData.setCareInfo('bmi', 0);
                storeData.setCareInfo('interest_disease', '');
                storeData.setCareInfo('work_strength', '');
                storeData.setCareInfo('goal', '');
                storeData.setCareInfo('food', '');
                storeData.setCareInfo('reset', 'Y');
                navigate('/care/careStep');
              }} >
              맞춤플랜 설정 다시 하기
            </Button>
          </Box>
        )}

      </Grid>
      <Bottom />
    </Stack >
  );
}

const accordionStyle = {
  borderRadius: '10px',
  position: 'static',
  mb: 1,
  '& .Mui-expanded': { color: '#d16300', fontWeight: 700 },
  '& .Mui-expanded p': { fontWeight: 700 },
  ':last-of-type ': { borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', },
};

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 5,
  boxSizing: 'border-box',

};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#fff',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#EF8322',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '50%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },

});

export default CareMenu;